import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CloudLightning"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.6247 16.4999H17.2497V14.9999H17.6247C19.4886 15.0745 21.0601 13.6239 21.1347 11.7599C21.2092 9.89596 19.7586 8.32448 17.8947 8.24992H17.2497L17.1747 7.63492C16.8305 5.02314 14.604 3.07083 11.9697 3.07083C9.3353 3.07083 7.10885 5.02314 6.76467 7.63492L6.74967 8.24992H6.10467C4.24071 8.32448 2.79011 9.89596 2.86467 11.7599C2.93923 13.6239 4.51071 15.0745 6.37467 14.9999H6.74967V16.4999H6.37467C3.884 16.4841 1.80577 14.5934 1.55527 12.1153C1.30476 9.63724 2.96255 7.36884 5.39967 6.85492C6.06688 3.74306 8.81709 1.52002 11.9997 1.52002C15.1823 1.52002 17.9325 3.74306 18.5997 6.85492C21.0368 7.36884 22.6946 9.63724 22.4441 12.1153C22.1936 14.5934 20.1153 16.4841 17.6247 16.4999ZM11.9022 22.8749L10.5972 22.1249L12.9597 17.9999H8.45965L12.0972 11.6249L13.4022 12.3749L11.0397 16.4999H15.5397L11.9022 22.8749Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CloudLightning.vue"]]);
